class LocalizationCustomForm extends HTMLElement {
  constructor() {
      super();

      this.languageItems = this.querySelectorAll('.language_item');
      this.languageSwitcher = this.querySelector('language-switcher');
      this.languageSwitcherButton = this.languageSwitcher?.querySelector('button');
      this.languageSwitcherDropdown = this.languageSwitcher?.querySelector('.language_list');

      if (!this.languageSwitcherButton || !this.languageSwitcherDropdown) {
          return;
      }

      this.initEventListeners();
  }

  initEventListeners() {
      // Event listener cho language items
      if (this.languageItems) {
          this.languageItems.forEach((item) => {
              item.addEventListener('click', (e) => {
                  e.stopPropagation(); // Ngăn event bubble up
                  this.handleLanguageClick(item);
              });
          });
      }

      // Event listener cho button trong language-switcher
      if (this.languageSwitcherButton) {
          this.languageSwitcherButton.addEventListener('click', (e) => {
              e.stopPropagation(); // Ngăn event bubble up
              this.toggleDropdown();
          });
      }

      // Thêm event listener cho document để đóng dropdown khi click outside
      document.addEventListener('click', (e) => {
          if (!this.closest('.language-switcher-container').contains(e.target)) {
              this.closeDropdown();
          }
      });
  }

  handleLanguageClick(item) {
      const localeValue = item.getAttribute('data-value');
      if (!localeValue) {
          return;
      }

      const form = document.querySelector('localization-hidden');
      if (!form) {
          return;
      }

      const localeInput = form.querySelector('#LocaleSelector');
      if (!localeInput) {
          return;
      }

      // Cập nhật giá trị và submit form
      localeInput.value = localeValue;
      form.querySelector('form').submit();
  }

  // Bật/tắt dropdown ngôn ngữ
  toggleDropdown() {
      this.languageSwitcher.classList.toggle('active');
      this.languageSwitcher.closest('.language-switcher-container').classList.toggle('active');
  }

  // Đóng dropdown
  closeDropdown() {
      this.languageSwitcher.classList.remove('active');
      this.languageSwitcher.closest('.language-switcher-container').classList.remove('active');
  }
}

// Đăng ký custom element
customElements.define('localization-custom-form', LocalizationCustomForm);

// Thêm event listener cho container từ bên ngoài
document.addEventListener('DOMContentLoaded', function() {
  const containers = document.querySelectorAll('.language-switcher-container');
  
  containers.forEach(container => {
      container.addEventListener('click', function(e) {
          // Tìm localization-custom-form bên trong container
          const customForm = container.querySelector('localization-custom-form');
          
          if (customForm) {
              // Kiểm tra xem click có phải từ button hoặc language item không
              if (!e.target.closest('button') && !e.target.closest('.language_item')) {
                  customForm.toggleDropdown();
              }
          }
      });
  });
});